import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getIsEditModeEnabled = createSelector(cartState, (cart) => !!cart?.isAddressInEditMode);
